import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as ngswal from "sweetalert";
import { ApiMethod } from '../../apimethods/api-method';
import { customfunctions } from '../../common/customfunctions';
import { GlobalConstants } from '../../common/global-constants';
import { FreelancerOnboardingAPIModel } from './freelancer-onboardingmodel';
declare var $;

@Component({
  selector: 'app-freelancer-onboarding',
  templateUrl: './freelancer-onboarding.component.html',
  styleUrls: ['./freelancer-onboarding.component.css']
})
/** register component*/
export class FreelancerOnboardingComponent implements OnInit {
  modelItem = new FreelancerOnboardingAPIModel();
  public CountryList: any;
  public CityList: any;
  CityIDPop: any;
  public StateList: any;
  StateIDPop: any;
  public interestList: any;
  public restrictionList: any;
  public sourceList: any;
  public languageList: any;
  status: boolean = false;
  file: File = null;
  fileBase64: any;
  Freelancerid: any;
  vendorname: any;
  DownloadFilepath: any;
  currentyear: string;
  CategoryList: any;


  /** register ctor */
  ngOnInit() {

    this.route.queryParamMap.subscribe(params => {
      if (params.get("Flid") != null) {
        alert('yes');
        localStorage.aEID = params.get("Flid");
        localStorage.aLoginID = params.get("Flid");
        $("#LoadingImage").show();
        var userItem = {
          RoleId: 24
        };
        ApiMethod.postMethod("api/menuaccessList", userItem).subscribe(
          resonse => {
            let aMenuList = resonse.aMenuAccessList;
            localStorage.aMenuList = JSON.stringify(aMenuList);

            $("#LoadingImage").hide();
          },
          error => {
            console.error(error)
            $("#LoadingImage").hide();
          }
        );

      }
      else {
        localStorage.aEID = localStorage.aLoginID;
        // ngswal("Warning !", 'Invalid URL !', "warning");
      }
    });
  }

  constructor(private router: Router, private route: ActivatedRoute) {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <FreelancerOnboardingAPIModel>data["FreelancerRegisterPage"];
        var hegiht = (GlobalConstants.size.height - 500);
        $('.container-fluid').css('height', GlobalConstants.size.height - 140);
        this.ClearData()
        $('#ULTabul').hide();


        $('#ddlCountry').select2({
          placeholder: "Select Country",
          /*allowClear: true, tags: true,*/

        });
        //$('#ddlCountry').val([]).trigger('change');
        $('#ddlState').select2({
          placeholder: "Select State",
          /*allowClear: true, tags: true,*/

        });
        $('#ddlCity').select2({
          placeholder: "Select City",
          /*allowClear: true, tags: true,*/

        });

        $('#ddlSourceList').select2({
          placeholder: "Select Source",
          allowClear: true, tags: true,

        });
        $('#ddlSourceList').val([]).trigger('change');

       
        $('#ddlLanguageList').select2({
          placeholder: "Select Language",
          allowClear: true, tags: true,

        });
        $('#ddlLanguageList').val([]).trigger('change');

        $('#ddlInterestList').select2({
          placeholder: "Select interest",
          allowClear: true, tags: true,

        });
        $('#ddlInterestList').val([]).trigger('change');

        $('#ddlRestrictionList').select2({
          placeholder: "Select Restriction",
          allowClear: true, tags: true,

        });
        $('#ddlRestrictionList').val([]).trigger('change');


        $('#ddlcategory').select2({
          placeholder: "Select Category",
          allowClear: true, tags: true,

        });
        $('#ddlcategory').val([]).trigger('change');

        this.GetSourceList();
        this.GetLanguageList();
        this.GetInterestList();
        this.GetRestrictionList();
        this.GetCountryList();
        this.GetCategoryList();

        $('#ddlCountry').change(function () {
          //alert('no');
          $('#btnCountry').trigger("click");
        });
        $('#ddlState').change(function () {
          //alert('no');
          $('#btnState').trigger("click");
        });
        $('#ddlTOW').select2({
          placeholder: "Select Work Type",
         
        });
        $('#ddlGender').select2({
          placeholder: "Select Gender",

        });
        
      },
      error => {
        ngswal("Warning !", error.message, "warning");
      });

  }


  //Get All Countries list
  GetCountryList(): void {
    
    ApiMethod.getMethod(this.modelItem.CountryListAPI).subscribe(
      result => {
        this.CountryList = result.aCountryList;
        $('#ddlState').val(0).change();
        $('#ddlCity').val(0).change();
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  //Get State by Country
  GetState() { //StateID = 0, CityID = 0
    
    ApiMethod.getMethod(this.modelItem.StateListAPI + $('#ddlCountry').val()).subscribe(
      result => {
        
        this.CityList = "";
        this.StateList = result.aStateList;
        $('#ddlState').val(0).change();
        //this.StateIDPop = StateID;
        //if (CityID > 0)
        //  this.GetCity(StateID, CityID);
      },
      error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }

  //Get City by State
  GetCity(){
    let nstateId = $('#ddlState').val();
    //if (nstateId == null) {
    //  nstateId = StateID;
    //}

    ApiMethod.getMethod(this.modelItem.CityListAPI + nstateId).subscribe(
      result => {
        this.CityList = result.aCityList;
        //this.CityIDPop = CityID;
      },
      error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }

  //Get All source list
  GetSourceList(): void {
    ApiMethod.getMethod(this.modelItem.SourceListAPI).subscribe(
      result => {
        this.sourceList = result.aSourceList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  //Get All Language list
  GetLanguageList(): void {
    ApiMethod.getMethod(this.modelItem.LanguageListAPI).subscribe(
      result => {
        this.languageList = result.aLanguageList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  //Get All Interest list
  GetInterestList(): void {
    ApiMethod.getMethod(this.modelItem.InterestListAPI).subscribe(
      result => {
        this.interestList = result.aInterestList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  //Get All restriction list
  GetRestrictionList(): void {
    ApiMethod.getMethod(this.modelItem.InterestListAPI).subscribe(
      result => {
        this.restrictionList = result.aInterestList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  //Get All Category list
  GetCategoryList(): void {
    ApiMethod.getMethod(this.modelItem.CategoryListAPI).subscribe(
      result => {
        this.CategoryList = result.aCategoryList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  //EmailID validation
  emailIdOnly(event): boolean {
    var filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    if (!filter.test(event.currentTarget.value)) {
      event.currentTarget.value = "";
      return ngswal("Warning !", "email not valid", "warning");
    }
    return true;
  }
  //phone number validation
  numbervalidate(event): boolean {
    const phoneRegex = /^\d{10}$/;
    if (!phoneRegex.test(event.currentTarget.value)) {
      event.currentTarget.value = "";
      return ngswal("Warning !", "Number not valid", "warning");
    }
    return true;
  }

  // check duplication email
  onSearchChange(event): void {
    this.checkJournal(event.currentTarget.value);
  }

  checkJournal(searchValue) {
    $("#LoadingImage").show();

    var filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    if (!filter.test(searchValue)) {
      searchValue = "";
      $("#LoadingImage").hide();
      return ngswal("Warning !", "email not valid", "warning");
    }
    var EmailID;

    if (searchValue == "")
      EmailID = $("#Txt_EmailID").val()
    else
      EmailID = searchValue;


    var FreelancerData = {
      EmailID: EmailID,
    };

    ApiMethod.postMethod(this.modelItem.CheckDuplicateAPI, FreelancerData).subscribe(
      response => {
        $("#LoadingImage").hide();

        if (response.status == "duplicate") {
          this.status = true;
          $("#txtTitle").val("");
          ngswal("Failed !", response.message, "error");
          return this.status;
        }
        else {
          this.status = false;
          return this.status;
        }
      }, error => {
        $("#LoadingImage").hide();

        ngswal("Failed !", error.error.Message, "error");
      });
    return this.status;
  }


  // Freelancer Register
  AddFreelancer(): void {
    if ($('#Txt_Name').val() == '') {
      ngswal("Warning !", "Enter First Name!", "warning");
    } else if ($('#Txt_LastName').val() == '') {
      ngswal("Warning !", "Enter Last Name!", "warning");
    }else if ($('#Txt_EmailID').val() == '') {
      ngswal("Warning !", "Enter EmailID!", "warning");
    } else if ($('#ddlSourceList').val() == null) {
      ngswal("Warning !", "Select Source status!", "warning");
    } else if ($('#ddlLanguageList').val() == null) {
      ngswal("Warning !", "Select Language !", "warning");
    } else if ($('#ddlInterestList').val() == null) {
      ngswal("Warning !", "Select Interest !", "warning");
    } else if ($('#ddlRestrictionList').val() == null) {
      ngswal("Warning !", "Select Restriction !", "warning");
    } else if ($('#Txt_mobile').val() == '') {
      ngswal("Warning !", "Enter ContactNo!", "warning");
    } else if ($('#Txt_DOB').val() == '') {
      ngswal("Warning !", "Enter DOB!", "warning");
    } else if ($('#ddlTOW').val() == null || $('#ddlTOW').val() == "") {
        ngswal("Warning !", "Select Work Type!", "warning");
    } else if ($('#ddlGender').val() == null || $('#ddlGender').val() == "") {
      ngswal("Warning !", "Select Gender!", "warning");
    } else if ($('#Txt_address').val() == '') {
      ngswal("Warning !", "Enter Address!", "warning");
    } else if ($('#Txt_pincode').val() == '') {
      ngswal("Warning !", "Enter pincode!", "warning");
    } else if ($('#ddlCountry').val() == null) {
      ngswal("Warning !", "Select Country!", "warning");
    } else if ($('#ddlState').val() == '') {
      ngswal("Warning !", "Select State!", "warning");
    } else if ($('#ddlCity').val() == '') {
      ngswal("Warning !", "Select City", "warning");
    } else if ($('#ddlcategory').val() == null) {
      ngswal("Warning !", "Select Category", "warning");
    } else if ($('#doc_file').val() == "") {
      $('#doc_file').val("");
      ngswal("Failed !", "Please upload Resume..!", "warning");
    }
    else {

      $("#LoadingImage").show();

      var FreelancerData = {
        //Primary data
        VendorName: $('#Txt_Name').val(),
        MiddleName: $('#Txt_MiddleName').val(),
        LastName: $('#Txt_LastName').val(),
        EmailID: $('#Txt_EmailID').val(),
       // MicrosoftTeamId: $('#Txt_TeamID').val(),
        Source: $('#ddlSourceList').val().toString(),
        ActiveStatus: 'InActive',
        Languages: $('#ddlLanguageList').val().toString(),
        Interest: $('#ddlInterestList').val().toString(),
        Restriction: $('#ddlRestrictionList').val().toString(),
        Remarks: $('#Txt_Remarks').val(),
        Category: $('#ddlcategory').val().toString(),
        Notes: $('#Txt_Notes').val(),
        //Personal details
        AlternateEmailID: $('#Txt_TeamID').val(),
        ContactNo: $('#Txt_mobile').val(),
        DOB: $('#Txt_DOB').val(),
        Gender: $('#ddlGender').val(),
        TypeOfWork: $('#ddlTOW').val(),
        Address: $('#Txt_address').val(),
        ZIPPostCode: $('#Txt_pincode').val(),
        Country: ($('#ddlCountry').val() == null ? null : $('#ddlCountry').val().toString()),
        City: $('#ddlCity').val().toString(),
        StateProvince: $('#ddlState').val().toString(),
        //bank details
        Image: $('#imgProfile').attr('src'),
        UpdatedBy: 1,
        //PublisherID: localStorage.aPubID.toString(),
        fileName: this.file.name,
        fileSize: this.file.size,
        fileAsBase64: this.fileBase64,
      };

      ApiMethod.postMethod(this.modelItem.UpdateFreelancerAPI, FreelancerData).subscribe(
        result => {
          if (result.status) {

            $("#LoadingImage").hide();
            this.ClearData();
            ngswal({
              position: "top-end",
              type: "success",
              title: "Updated Successfully!",
              text: "Thank You !",
              showConfirmButton: true,

            });
          } else if (result.status == "duplicate") {
            $("#LoadingImage").hide();

            ngswal("Failed !", result.message, "warning");
          } else {
            $("#LoadingImage").hide();
            ngswal("Failed !", result.message, "error");
          }
        },
        error => {
          ngswal("Failed!", error.error.Message, "error");
          $("#LoadingImagePopup").hide();
        }
      );
    }
  }

  //cleardata
  ClearData(): void {
    $('#Txt_Name').val('');
    $('#Txt_MiddleName').val('');
    $('#Txt_LastName').val('');
    $("#ddlActive").val(0).change();
    $('#Txt_EmailID').val('');
    $('#Txt_TeamID').val('');
    $("#ddlAvaliable").val(0).change();
    $('#Txt_FromDate').val('');
    $('#Txt_ToDate').val('');
    $("#ddlPublisherList").val(0).change();
    $("#ddlSourceList").val(0).change();
    $("#ddlInterestList").val(0).change();
    $("#ddlLanguageList").val(0).change();
    $("#ddlRestrictionList").val(0).change();
    $("#ddlJournalList").val(0).change();
    $("#ddlcategory").val(0).change();
    $('#Txt_Remarks').val('');
    $('#Txt_AltEmailID').val('');
    $('#Txt_mobile').val('');
    $('#Txt_DOB').val('');
    $('#Txt_fascimile').val('');
    $('#ddlGender').val(-1).change();
    $('#ddlTOW').val(-1).change();
    $('#Txt_address').val('');
    $('#Txt_pincode').val('');
    $('#Txt_Webaddress').val('');
    $('#Txt_weblink').val('');
    $('#Txt_BankName').val('');
    $('#Txt_AccNo').val('');
    $('#Txt_IFSC').val('');
    $('#Txt_Branch').val('');
    $('#ddlNDAdoc').val(0).change();
    $('#Txt_PAN').val('');
    $("#ddlCountry").val(0).change();
    $("#ddlState").val('').change();
    $("#ddlCity").val('').change();
    $("#tblTask tbody").html("");
    $('#imgProfile').attr('src', '../../../assets/Images/userLogo.jpg');
    $("#imageUploadForm").val(null);
    $("#doc_file").val(null);
    $("#LoadingImage").hide();
    $("#Txt_Notes").val('');
    $('a[href="#divPrimary"]').click();
  }

  onerrorImageLoad() {
    var zActHostpath = document.location.pathname.split('/')[1];
    $('#imgProfile').attr('src', '/' + zActHostpath + "../../../assets/Images/userLogo.jpg");
  }
  // showPreview Image Upload
  showPreview(event) {
    var ext = $('#imageUploadForm').val().split('.').pop().toLowerCase();
    if ($.inArray(ext, ['png', 'jpg', 'jpeg']) == -1) {
      $('#imageUploadForm').val("");
      $('#imgProfile').attr('src', '../../../assets/Images/userLogo.jpg');

      ngswal("Failed !", "Invalid Image format", "warning");
      return false;
    }
    else if (event.target.files[0].size > 2000000) {
      $('#imageUploadForm').val("");
      $('#imgProfile').attr('src', '../../../assets/Images/userLogo.jpg');
      ngswal("Failed !", "Please upload photo less than 2MB", "warning");
      return false;
    }
    if (event.target.files[0]) {
      var fileReader = new FileReader();
      fileReader.onload = function (e) {
        $('#imgProfile').attr('src', fileReader.result);
      }
      fileReader.readAsDataURL(event.target.files[0]);
    }
  }
  //resume fileupload
  onFileSelected(fileInput: any) {

    var ext = $('#doc_file').val().split('.').pop().toLowerCase();
    if ($.inArray(ext, ['doc', 'docx', 'pdf']) == -1) {
      $('#doc_file').val("");
      ngswal("Failed !", "Invalid File format", "warning");
      return false;
    } else if (fileInput.target.files[0].size > 50000) {
      $('#doc_file').val("");
      ngswal("Failed !", "Please upload File less than 50KB", "warning");
      return;
    } else {
      this.file = fileInput.currentTarget.files[0];
      if (fileInput.currentTarget.files[0]) {

        var fileReader = new FileReader();
        fileReader.onload = (e: any) => {
          this.fileBase64 = null;

          this.fileBase64 = e.currentTarget.result;
        }
        fileReader.readAsDataURL(fileInput.currentTarget.files[0]);
      }
    }
  }
  //DOB validation
  Dobdatevalidation(event) {
    var x = new Date($("#Txt_DOB").val());
    var Cnow = new Date();
    if ($("#Txt_DOB").val() == "") {
      $("#Txt_DOB").focus();
    }
    else if (Cnow.getFullYear() - x.getFullYear() < 18) {
      ngswal("Failed !", "DOB Not Valid", "warning");
      /*$("#Txt_DOB").val('');*/
    }
  }

 

}

